import { getAllActiveRooms } from "@/services/home.services";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IRoomInitialState {
  loading: boolean;
  formLoading: boolean;
  roomImageLoading: boolean;
  error: string;
  RoomList: IRoom[];
  RoomID: number | null;
  RoomImageID: number | null;
  RoomDetail: IRoomDetails;
}

export interface IRoomDetails {
  ID?: number | null;
  RoomTitle: string;
  RoomDescription: string;
  Rates: number | null;
  Roomsize?: string;
  Occupancy?: string;
  RoomView?: string;
  BedType?: string;
  RoomHighlights?: string;
  MetaTitle?: string;
  MetaKeywords?: string;
  MetaDescription?: string;
  SequenceNo: number | null;
  Images: string;
  IsActive: number;
  RoomInnerimage?: any[];
  RoomFacilities?: IRoomFacilities[];
}

export interface IRoomFacilities {
  RoomFacilities: string;
}

export interface IRoom {
  ID?: number | null;
  RoomTitle: string;
  RoomURL: string;
  BookingURL: string;
  RoomDescription: string;
  Rates: number;
  Roomsize?: string;
  Occupancy?: string;
  RoomView?: string;
  BedType?: string;
  RoomHighlights?: string;
  FacilityName?: string;
  FacilityTitle?: string;
  MetaTitle?: string;
  MetaKeywords?: string;
  MetaDescription?: string;
  SequenceNo: number | null;
  Images: string;
  IsActive: number;
  RoomInnerimage?: any[];
  RoomFacilities?: IRoomFacilities[];
}

const initialState: IRoomInitialState = {
  loading: false,
  formLoading: false,
  roomImageLoading: false,
  error: "",
  RoomID: null,
  RoomImageID: null,
  RoomList: [],
  RoomDetail: {
    ID: null,
    RoomTitle: "",
    RoomDescription: "",
    Rates: null,
    Roomsize: "",
    Occupancy: "",
    RoomView: "",
    BedType: "",
    RoomHighlights: "",
    MetaTitle: "",
    MetaKeywords: "",
    MetaDescription: "",
    SequenceNo: null,
    Images: "",
    IsActive: 1,
    RoomFacilities: [],
  },
};

const roomSlice = createSlice({
  name: "room",
  initialState,
  reducers: {
    clearRoomDetails: (state) => {
      state.RoomDetail = initialState.RoomDetail;
    },
    setRoomID: (state, action) => {
      state.RoomID = action.payload;
    },
    clearRoomID: (state) => {
      state.RoomID = initialState.RoomID;
    },
    setRoomImageID: (state, action) => {
      state.RoomImageID = action.payload;
    },
    clearRoomImageID: (state) => {
      state.RoomImageID = initialState.RoomImageID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActiveRooms.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveRooms.fulfilled,
      (state, action: PayloadAction<IRoom[]>) => {
        state.loading = false;
        state.RoomList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveRooms.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.RoomList = [];
    });
  },
});

export const {
  clearRoomDetails,
  clearRoomID,
  setRoomID,
  setRoomImageID,
  clearRoomImageID,
} = roomSlice.actions;
export default roomSlice.reducer;
